<template>
  <el-dialog title="机械费详情" width="1188px" :visible="isShow" :close-on-click-modal="false" @close="closeDialog">
    <el-form
      ref="formData"
      :model="info"
      label-position="right"
      label-width="80px">
      <div class="flex">
        <el-form-item label="所属项目" prop="projectId">
          <el-select disabled v-model="info.projectId" filterable  placeholder="请选择所属项目">
            <el-option
              v-for="item in projectList"
              :key="item.projectId"
              :label="item.projectName"
              :value="item.projectId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="machineTeamDate" label="台班日期">
          <el-date-picker
            disabled
            v-model="info.machineTeamDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择台班日期">
          </el-date-picker>
        </el-form-item>
      </div>

      <el-form-item class="mb20" label="台班机械" prop="machineTeamLines">
        <el-table
          class="global-table global-tables mb30 my-table"
          max-height="400"
          :data="info.machineTeamLines"
          :summary-method="getSummaries"
          show-summary
          border
          ref="table">
          <el-table-column label="机械名称" prop="machineryName"  align='center'>
          </el-table-column>
          <el-table-column label="规格型号" prop="specificationModel"  align='center' showOverflowTooltip>
          </el-table-column>
          <el-table-column label="供应商名称" prop="supplierId"  align='center' showOverflowTooltip>
            <template v-slot="{ row}">
              <div style="overflow: hidden;">{{ row.supplierName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="是否含油" align='center'>
            <template v-slot="{ row}">
              <div  >{{row.whetherOil === '1' ? '是' : '否'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="作业内容" prop="jobContent" align='center'  showOverflowTooltip >
          </el-table-column>
          <el-table-column label="台班/小时数" prop="hours" align='center' showOverflowTooltip>
          </el-table-column>
          <!-- <el-table-column label="单价(元)" prop="price" align='center' showOverflowTooltip>
          </el-table-column> -->
          <el-table-column label="台班金额" prop="teamPrice" align='center' showOverflowTooltip>
          </el-table-column>
          <el-table-column label="备注" prop="lineRemark" align='center' showOverflowTooltip>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item prop="headRemark" label="备注信息">
        <p>{{info.headRemark || '--'}}</p>
      </el-form-item>
      <el-form-item label="现场图片" prop="fileList">
        <div class="imgList">
          <div class="imgBlock" v-for="(item, index) in info.fileList" :key="index">
            <el-image
              :src="item.filePrefix + item.fileUrl"
              :preview-src-list="info.fileList | imgListFormat"
              fit="fill">
            </el-image>
          </div>
        </div>
        <div class="mt20">(最多六张)</div>
      </el-form-item>
    </el-form>
    <div class="section-page">
      <i class="iconfont icon-fanye prev" :class="{ disabled: page <= 1 }" @click="changePage(-1)"></i>
      <span class="num">{{idList ? idList.length : 0}}</span>
      <i class="iconfont icon-fanye" :class="{ disabled: page >= idList.length }" @click="changePage(1)"></i>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DetailList',
  props: {
    idList: {
      type: Array,
      default: () => {
        return []
      }
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    imgListFormat (list) {
      const imgList = list.map((item) => {
        return item.filePrefix + item.fileUrl
      })
      return imgList || []
    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList || []
    }
  },
  watch: {
    isShow (val) {
      this.page = 1
      if (val && this.idList && this.idList.length) {
        this.getDetail()
      }
    }
  },
  data () {
    return {
      page: 1,
      info: {
        // 基础信息
        projectId: '',
        machineTeamDate: '',
        machineTeamLines: [],
        headRemark: '',
        fileList: []
      }
    }
  },
  created () {
  },
  methods: {
    initData () {
      this.info = {
        // 基础信息
        projectId: '',
        machineTeamDate: '',
        machineTeamLines: [],
        headRemark: '',
        fileList: []
      }
      this.page = 1
    },
    changePage (num) {
      const page = this.page + num
      if (page >= 1 && page <= this.idList.length) {
        this.page = page
        this.getDetail()
      }
    },
    getDetail () {
      this.$axios.get(this.$apis.machine.selectYhMachineTeamByMachineTeamId, {
        machineTeamId: this.idList[this.page - 1]
      }).then(res => {
        if (res) {
          res.machineTeamLines.forEach((item) => {
            item.isFirstAllChoose = true
          })
          this.info = res
        }
      })
    },
    getSummaries (param) {
      const { data } = param
      let total = 0
      data.forEach((item) => {
        if (/^([1-9][0-9]*|[0-9])(\.\d)?$/.test(item.teamPrice)) {
          total += parseFloat(item.teamPrice)
        }
      })
      return ['合计', '', '', '', '', '', total, '']
    },
    // 关闭
    closeDialog () {
      this.initData()
      this.$emit('update:isShow', false)
    }
  }
}
</script>

<style scoped lang="scss">
  .global-form2 .el-textarea {
    width: 380px;
  }

  ::v-deep .el-table__body{
    .el-form-item__content{
      margin-left: 0 !important;
    }
    .el-input{
      width: 100%;
    }
    .el-select{
      width: 100%;
    }
    .el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      padding-top: 4px;
      position: absolute;
      top: 93%;
      left: 0px;
      z-index: 9999;
    }
    .el-table__row{
      height: 62px;
    }
  }
  .flex{
    display: flex;
    .el-form-item{
      flex:1 !important
    }
  }

  .imgList{
    width: 100%;
    min-height: 104px;
    display: flex;
    margin-top: 15px;
    flex-wrap: wrap;
    .imgListTitle{
      margin-right: 10px;
    }
    .imgBlock {
      position: relative;
      height: 104px;
      width: 104px;
      margin:0 10px 10px 0 !important;
      .el-image,img,video{
        width:100%;
        height: 100%;
      }
    }
    ::v-deep .el-upload--picture-card{
      width: 104px;
      height: 104px;
      line-height: 26px;
      padding:25px 10px;
      i{
        font-size: 22px;
        color: #999;
        margin-bottom: 7px;
      }
    }
    ::v-deep .el-upload{
      display: flex;
      flex-direction: column;
      justify-content: center !important;
      align-items: center !important;
    }
  }
  .section-page {
    display: flex;
    justify-content: center;
    align-items: center;
    .num {
      width: 52px;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      text-align: center;
    }
    .iconfont {
      font-size: 20px;
      color: rgba(64, 158, 255, 0.9);
      cursor: pointer;
      &.prev {
        transform: rotateY(180deg);
      }
    }
    .disabled {
      color: rgba(64, 158, 255, 0.5);
      cursor: not-allowed;
    }
  }
</style>
